// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__2pbwc","content":"LayoutSettings_content__20_NL"};